import styled from 'styled-components';

export const ConnectedChildren = styled.div<{ $gap?: string }>`
	margin-left: 0.5rem;
	display: flex;
	flex-direction: column;
	gap: ${({ $gap }) => $gap ?? '0.25rem'};

	& > * {
		position: relative;
	}

	& > *:not(:last-child) {
		border-left: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}

	& > *:not(:last-child)::before {
		content: '';
		position: absolute;
		left: 0;
		bottom: 50%;
		width: 8px;
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	}

	& > *:last-child {
		padding-left: 1px;
	}

	& > *:last-child::before {
		content: '';
		position: absolute;
		left: 0;
		bottom: 50%;
		width: 9px;
		height: calc(50% + ${({ $gap }) => $gap ?? '4px'});
		border-left: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-bottom-left-radius: 4px;
	}
`;
